import Api from "~/service/Api";

class PhotoEditingJobRepository {
  fetch(query = {}) {
    return Api.get("/photo-editing/jobs", query);
  }

  fetchOne(photoEditingJobId) {
    return Api.get(`/photo-editing/jobs/${photoEditingJobId}`);
  }

  delete(photoEditingJobId) {
    return Api.delete(`/photo-editing/jobs/${photoEditingJobId}`);
  }

  create(tourId, typeId) {
    return Api.post("/photo-editing/jobs", {
      tourId,
      typeId,
    });
  }

  /**
   *
   * @param {number} photoEditingJobId
   * @returns {string}
   */
  getDownloadProcessedImagesUrl(photoEditingJobId) {
    return `/api/photo-editing/jobs/${photoEditingJobId}/download-processed-images`;
  }

  refund(photoEditingJobId) {
    return Api.post(`/photo-editing/jobs/${photoEditingJobId}/refund`);
  }
}

export default PhotoEditingJobRepository;
